import { render, staticRenderFns } from "./YouTubeSetModerationStatus.vue?vue&type=template&id=36e8a85c&scoped=true"
import script from "./YouTubeSetModerationStatus.vue?vue&type=script&lang=js"
export * from "./YouTubeSetModerationStatus.vue?vue&type=script&lang=js"
import style0 from "./YouTubeSetModerationStatus.vue?vue&type=style&index=0&id=36e8a85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8a85c",
  null
  
)

export default component.exports